export default __webpack_public_path__ + "static/media/chevron-down.e4cd78c2.svg";